// import { useState, useEffect } from 'react';

// export default function Navbar() {
//   const [isScrolled, setIsScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navLinks = [
//     { name: 'Home', path: '/' },
//     { name: 'Products', path: '/products' },
//     { name: 'About Us', path: '/about' },
//     { name: 'Work Culture', path: '/culture' },
//     { name: 'Contact Us', path: '/contact' },
//   ];

//   const scrollToSection = (id: string) => {
//     if (id === 'products-page') {
//       window.REACT_APP_NAVIGATE('/products');
//       return;
//     }
//     if (id === 'about-page') {
//       window.REACT_APP_NAVIGATE('/about');
//       return;
//     }
//     const element = document.getElementById(id);
//     if (element) {
//       element.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   return (
//     <nav
//       className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
//         isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
//       }`}
//     >
//       <div className="max-w-7xl mx-auto px-6 py-4">
//         <div className="flex items-center justify-between">
//           <div className="flex items-center">
//             <img
//               src="/assets/logo.png"
//               alt="Ester LifeSciences Logo"
//               className="h-12 w-auto object-contain"
//             />
//           </div>

//           <div className="hidden md:flex items-center space-x-8">
//             <button
//               onClick={() => scrollToSection('home')}
//               className={`text-sm font-medium transition-colors hover:text-teal-600 relative group ${
//                 isScrolled ? 'text-gray-700' : 'text-white'
//               }`}
//             >
//               Home
//               <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-600 transition-all group-hover:w-full"></span>
//             </button>
//             <button
//               onClick={() => scrollToSection('about-page')}
//               className={`text-sm font-medium transition-colors hover:text-teal-600 relative group ${
//                 isScrolled ? 'text-gray-700' : 'text-white'
//               }`}
//             >
//               About Us
//               <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-600 transition-all group-hover:w-full"></span>
//             </button>
//             <button
//               onClick={() => scrollToSection('products-page')}
//               className={`text-sm font-medium transition-colors hover:text-teal-600 relative group ${
//                 isScrolled ? 'text-gray-700' : 'text-white'
//               }`}
//             >
//               Products
//               <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-600 transition-all group-hover:w-full"></span>
//             </button>
//             <button
//               onClick={() => scrollToSection('services')}
//               className={`text-sm font-medium transition-colors hover:text-teal-600 relative group ${
//                 isScrolled ? 'text-gray-700' : 'text-white'
//               }`}
//             >
//               Services
//               <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-600 transition-all group-hover:w-full"></span>
//             </button>
//             <button
//               onClick={() => scrollToSection('contact')}
//               className={`text-sm font-medium transition-colors hover:text-teal-600 relative group ${
//                 isScrolled ? 'text-gray-700' : 'text-white'
//               }`}
//             >
//               Contact
//               <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-600 transition-all group-hover:w-full"></span>
//             </button>
//           </div>

//           <button
//             onClick={() => scrollToSection('contact')}
//             className="hidden md:block bg-teal-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
//           >
//             Request Catalog
//             <i className="ri-arrow-right-line ml-2"></i>
//           </button>
//         </div>
//       </div>
//     </nav>
//   );
// }

import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItem = (path: string) =>
    `text-sm font-medium transition-colors relative cursor-pointer
     ${isScrolled ? 'text-gray-700' : 'text-white'}
     ${location.pathname === path ? 'text-teal-600' : 'hover:text-teal-600'}`;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">

          {/* LOGO */}
          <img
            src="/assets/logo_text.png"
            alt="Ester LifeSciences Logo"
            className="h-14 w-auto object-contain cursor-pointer"
            onClick={() => navigate('/')}
          />

          {/* DESKTOP NAV */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => navigate('/')} className={navItem('/')}>
              Home
            </button>

            <button onClick={() => navigate('/about')} className={navItem('/about')}>
              About Us
            </button>

            <button onClick={() => navigate('/products')} className={navItem('/products')}>
              Products
            </button>

            <button onClick={() => navigate('/culture')} className={navItem('/culture')}>
              Work Culture
            </button>

            <button onClick={() => navigate('/contact')} className={navItem('/contact')}>
              Contact Us
            </button>
          </div>

          {/* CTA */}
          <button
            onClick={() => navigate('/contact')}
            className="hidden md:block bg-teal-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-teal-700 transition-colors"
          >
            Request Catalog
          </button>

        </div>
      </div>
    </nav>
  );
}
